import { getStatus } from '../../../data/projectStatus';
import './StatusPill.css';

export default function StatusPill({ status, size = 'md', onDark = false }) {
  const { label, tone } = getStatus(status);
  const cls = [
    'status-pill',
    `status-pill--${tone}`,
    `status-pill--${size}`,
    onDark ? 'status-pill--on-dark' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={cls}>
      <span className="status-pill__dot" aria-hidden="true" />
      {label}
    </span>
  );
}
